import { i18n } from '@/i18n/i18n'
import Configuration from '../agilis/util/Configuration'

// helper per avere un setTimeout wrappato in async/await
function wait (waitInMs) {
  return new Promise((resolve) => {
    setTimeout(resolve, waitInMs)
  })
}

async function resolvePlaceholders (str, params = {}, retry = 0) {
  let sentence = str
  const placeholders = sentence.match(/:([a-zA-z0-9]+)/g) || [] // :<param>

  // When no placeholders to resolve, return
  if (placeholders.length === 0) return str

  try {
    // ///////////////////////////////////////////////////////////////////////////
    // quando la config ancora nn è stata caricata questo righe sparano eccezione:
    // mettiamo in piedi un sistema di retry
    params.applicationName = i18n.t(Configuration.getApplication(params.applicationId).name)
    params.workspaceName = Configuration.datatable.renderWorkspace(null, params)
    // ///////////////////////////////////////////////////////////////////////////

    placeholders.forEach(placeholder => {
      var phText = placeholder.substring(1, placeholder.length)
      if (params[phText]) {
        sentence = sentence.replace(placeholder, params[phText])
      }
    })
    return sentence
  } catch (e) {
    if (retry > 10) return '' // after 10 retry exit without replace

    const nextTry = retry + 1
    await wait(nextTry * 100)
    return resolvePlaceholders(str, params, nextTry)
  }
}

export const updateMeta = async (to, from) => {
  if (to?.meta?.title) {
    const title = await resolvePlaceholders(to.meta.title, to.params)
    document.title = title || 'ARPA '
  }
}
